import React from 'react'
import useAppContext from '../../hook/useAppContext'
import { FaDiscord, FaFacebookF, FaInstagram, FaTiktok, FaTumblr, FaTwitch, FaYoutube } from "react-icons/fa"
import { FaXTwitter } from "react-icons/fa6"
import SocialLink from './SocialLink'
import './socialmenu.css'

const SocialMenu = () => {

      const {user} = useAppContext()
      const {social} = user 

      if(social.code) return 

      const twitch = social.twitch === null ? '' : social.twitch 

      return (
            <div className="social_menu flex">
                  <SocialLink url={social.facebook} icon={<FaFacebookF />} />
                  <SocialLink url={social.twitter} icon={<FaXTwitter />} />
                  <SocialLink url={social.instagram} icon={<FaInstagram />} />
                  <SocialLink url={social.youtube} icon={<FaYoutube />} />
                  <SocialLink url={social.tiktok} icon={<FaTiktok />} />
                  <SocialLink url={social.discord} icon={<FaDiscord />} />
                  <SocialLink url={social.tumblr} icon={<FaTumblr />} />
                  <SocialLink url={twitch} icon={<FaTwitch />} />
            </div>
      )
}

export default SocialMenu
